import { normalizeCookieName } from '@loc/helpers/src/cookies'

import type { IUserInfo } from '@/contexts/SiteSpecificContext/types'

import { getCookie, removeCookie, setCookie } from '@/helpers/cookies.browser'
import { useCookieDomain } from '@/hooks/cookieDomain'
import { isBrowser } from '@/helpers/env'

import { useState, useEffect } from 'react';
export const USER_INFO_KEY = normalizeCookieName('user-info')

export function getCookieUserInfo() {
  const data = getCookie(USER_INFO_KEY)
  if (data) {
    return JSON.parse(data) as IUserInfo
  }
  return { id: '' }
}

export function useCookieUserInfo() {
  const { cookieDomain } = useCookieDomain()
  const [userInfoCookie, setUserInfoCookie] = useState<IUserInfo>(
    // 避免页面切换闪烁
    isBrowser() ? getCookieUserInfo() : { id: '' },
  )
  function updateCookieUserInfo(userInfo: IUserInfo) {
    setCookie(USER_INFO_KEY, JSON.stringify(userInfo), {
      maxAge: 90 * 24 * 60 * 60, // 30 days
      path: '/',
      domain: cookieDomain,
    })
    if (
      window.updateHtmlUserStatus &&
      typeof window.updateHtmlUserStatus === 'function'
    ) {
      window.updateHtmlUserStatus()
    }
    setUserInfoCookie(userInfo)
  }

  function removeCookieUserInfo() {
    removeCookie(USER_INFO_KEY, {
      path: '/',
      domain: cookieDomain,
    })
    if (
      window.updateHtmlUserStatus &&
      typeof window.updateHtmlUserStatus === 'function'
    ) {
      window.updateHtmlUserStatus()
    }
    setUserInfoCookie(getCookieUserInfo())
  }
  useEffect(() => {
    setUserInfoCookie(getCookieUserInfo())
  }, [])

  return {
    userInfoCookie,
    updateCookieUserInfo,
    removeCookieUserInfo,
  }
}
